<template>
    <div ref="alvo">
        <Email />
        <div v-if="$store.state.payment.email">
            <PreparingPlataform v-if="loaded == false" />
            <div v-else>
                <v-row align="center" justify="center" class="mt-2 mt-sm-0">
                    <v-col cols="6" xl="2" lg="2" md="3" sm="4" v-if="qrCodeImage">
                        <img :src="qrCodeImage" alt="QR Code" style="width: 100%; height: auto;" />
                    </v-col>
                    <v-col cols="12" v-if="pixUrl">
                        <v-btn color="success" class="mt-0 mb-12" style="width: 75%" @click="copyPixCode">
                            <v-icon left>mdi-content-copy</v-icon>
                            Pix Copia e Cola
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>
        <!-- <v-alert v-else :icon="$vuetify.breakpoint.xs ? '' : 'info'" :type="$vuetify.breakpoint.xs ? '' : 'success'" color="success white--text">
            Antes de continuar, por favor informe seu e-mail para fazermos o pagamento via PIX.
        </v-alert> -->
    </div>
</template>

<script>
import Email from "@/components/shared/Payment/Email";
import PreparingPlataform from "@/components/shared/Payment/PreparingPlataform";

export default {
    components: { Email, PreparingPlataform },

    props: {
        charger: {
            required: true,
        },
        chargerName: {
            required: true,
        },
        plugNumber: {
            required: true,
        },
        price: {
            required: true,
        },
    },

    data() {
        return {
            loaded: false,
            PREFERENCE_ID: null,
            qrCodeImage: null,
            pixUrl: null,
            errorCount: 0,
            errorOnCreatePayment: undefined,
            timer: null
        };
    },

    mounted() {
        this.createPreference();
        this.$eventHub.$on("changePaymentEmail", this.recreateButton);
        this.timer = setInterval(this.verify, 5000);
    },

    methods: {
        verify() {
            if (this.errorOnCreatePayment == true) {
                this.errorOnCreatePayment = undefined;
                this.errorCount = 0;
                this.createPreference();
            }
        },
        error(e) {
            this.errorCount++;
            if (this.errorCount > 5) {
                this.errorOnCreatePayment = true;
                this.$eventHub.$emit("msgError", e && e.message ? e.message : "Erro ao criar meio de pagamento.");
            } else {
                setTimeout(this.createPreference, 2000);
            }
        },
        recreateButton() {
            this.loaded = false;
            this.createPreference();
        },
        createPreference() {
            this.$http
                .postDynamic(this.charger.server, "api/v2/payment/create", {
                    operator: "mercadopagopix",
                    chargerName: this.chargerName,
                    plugNumber: this.plugNumber,
                    email: (this.$store.state.payment.email) ? this.$store.state.payment.email : null,
                    userId: (this.$store.state.user.ID) ? this.$store.state.user.ID : "NO_USER",
                    price: this.price
                })
                .then((result) => {
                    if (result && result.id && result.qrcode_base64 && result.qrcode) {
                        this.PREFERENCE_ID = result.id;
                        this.qrCodeImage = `data:image/png;base64,${result.qrcode_base64}`;
                        this.pixUrl = result.qrcode;
                        this.loaded = true;
                        this.$nextTick(() => {
                            this.$refs.alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        });
                    } else {
                        this.error();
                    }
                }).catch(this.error);

        },
        copyPixCode() {
            if (this.pixUrl) {
                navigator.clipboard.writeText(this.pixUrl).then(() => {
                    this.$eventHub.$emit("msgSuccess", "Copiado com sucesso, vá no aplicativo do seu banco e cole!");
                }).catch(() => {
                    this.$eventHub.$emit("msgError", "Erro ao copiar o código Pix.");
                });
            }
        },
    },

    beforeDestroy() {
        clearInterval(this.timer);
    },
}

</script>